module.exports = __webpack_public_path__ + "media/images/lb/141-1511a7e3c789d98f7e5dc4648ed64982.svg";